import api from "../api/axiosInstance";

const statusDefinitionService = {
    getAllGrouped: () => api.get("/status-definitions"),
    getByDomain: (domain) => api.get(`/status-definitions/${domain}`),
    create: (domain, payload) => api.post(`/status-definitions/${domain}`, payload),
    update: (domain, id, payload) => api.patch(`/status-definitions/${domain}/${id}`, payload),
    remove: (domain, id) => api.delete(`/status-definitions/${domain}/${id}`),
    reorder: (domain, orderedIds) => api.patch(`/status-definitions/${domain}/reorder`, { orderedIds }),
};

export default statusDefinitionService;
